import { useState } from 'react';
import Button from '@mui/material/Button';
import axios from 'axios';

export default function RetailerLookupButton({ form, setForm }) {
  const [loading, setLoading] = useState(false);

  const handleRetailerLookup = async e => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT_FORMS}/uscc/retailerLookup`,
        {
          retailerId: form.retailerId,
          jurisdiction: form.jurisdiction,
          userId: form.userId,
        }
      );

      // Update the formData state with the response data
      setForm(prevData => ({
        ...prevData,
        retailerName: response.data.retailerName, // Populate storeName field
        address: response.data.address, // Populate address field
        phoneNumber: response.data.phoneNumber, // Populate phoneNumber field
        zoneId: response.data.zoneId || null, // Populate zoneId field
        latitude: response.data.latitude || null, // Populate latitude field
        longitude: response.data.longitude || null, // Populate longitude field
      }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error searching Retailer:', error);
    }
  };

  return (
    <Button
      variant={'contained'}
      loading={loading}
      disabled={loading || !form.retailerId}
      onClick={handleRetailerLookup}
      sx={{
        backgroundColor: 'var(--procyon-green)',
        color: '#000000',
        fontFamily: 'BrightstarSans-Regular',
      }}
    >
      Retailer ID Lookup
    </Button>
  );
}
